import SyncableModel from './SyncableModel';

export default class Laboratory extends SyncableModel {
    static name = 'Laboratory'

    _fillable = [
      'id',
      'name',
      'short_name',
      'address',
      'postal_code',
      'region_id',
      'country_id',
      'phone',
      'email',
      'verified',
      'created_at',
      'updated_at',
      'synced_at',
      'deleted_at',
    ]

    static endpoint = '/laboratories'

    static syncOnly = true

    setRegionIdAttribute(value) {
      this._attributes = {
        ...this._attributes,
        region_id: value ? value.substring(0, 7) : value
      };
      return this;
    }
}
